module.exports = __webpack_public_path__ + "static/media/binaamal.6b033258.webp";